import * as React from 'react';

import { ProductSummary } from 'models/product';

import { GuestSelectModalView } from './GuestSelectModalView';

interface Props {
  date: string;
  product: ProductSummary | null;
  onClose: () => void;
}

export const GuestSelectModal = ({ date, product, onClose }: Props) => {
  return <GuestSelectModalView date={date} product={product} onClose={onClose} />;
};
